"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceSign2DeviceId = void 0;
/**
 * deviceSign转diviceId
 *
 * @param {string} deviceSign
 * @return {string | undefined}
 */
function deviceSign2DeviceId(deviceSign) {
    var deviceId = undefined;
    if (typeof deviceSign === 'string') {
        var pos = deviceSign.indexOf('.');
        if (pos > -1) {
            deviceId = deviceSign.substr(pos + 1, 32);
        }
        if (typeof deviceId !== 'string' || deviceId.length != 32) {
            deviceId = undefined;
        }
    }
    return deviceId;
}
exports.deviceSign2DeviceId = deviceSign2DeviceId;
//# sourceMappingURL=utils.js.map